import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { IAgentInfo } from 'src/entity/AgentEntity';
import WalletService, { IAccountInfo, EAccountMemberType, ERegisterStep } from 'src/services/WalletService';
import './wallet.css';

import bgImg from '../../../assets/imgs/bg-img.png';
import icon1 from '../../../assets/imgs/icon1.png';
import icon2 from '../../../assets/imgs/icon2.png';
import icon3 from '../../../assets/imgs/icon3.png';
import WalletDetailPage from './WalletDetailPage';

interface IWalletPageProps extends RouteComponentProps {
  isAgent: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
}

interface IWalletPageState {
  account: IAccountInfo[];
  /** 是否正在加载 */
  isLoading: boolean;
}

class WalletPage extends React.Component<IWalletPageProps, IWalletPageState> {
  private walletService = WalletService;

  constructor(props: IWalletPageProps) {
    super(props);
    this.state = { account: [], isLoading: true };
  }

  async componentDidMount() {
    this.initData();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  render() {
    const { isLoading, account: accounts } = this.state;
    const { userInfo } = this.props;
    const account = this.getAccount();
    const enterpriseAccount = this.getAccount(EAccountMemberType.Enterprise);
    const accountDeactive = !account || account.step < ERegisterStep.Opened;
    const enterpriseAccountDeactive = !enterpriseAccount || enterpriseAccount.step < ERegisterStep.Opened;

    if (isLoading) {
      return <div />;
    } else if (accountDeactive && enterpriseAccountDeactive) {
      // [企业账户|个人账户]都没有开通
      return (
        <div className="introduce-box">
          <img src={bgImg} />
          <div className="introduce-con">
            <div className="headline">
              <h1>安全 高效 便捷</h1>
              <h3>脉景为您提供全方位优质服务</h3>
              <button onClick={() => this.onRegister(EAccountMemberType.Individual)}>个人开户</button>
              <button onClick={() => this.onRegister(EAccountMemberType.Enterprise)}>企业开户</button>
              <p>您尚未开通脉景收款账户！</p>
            </div>
            <ul className="introduce-area">
              <li>
                <img src={icon1} />
                <h3>支付产品</h3>
                <p>满足各类交易场景中的快速收付款需求</p>
              </li>
              <li>
                <img src={icon2} />
                <h3>账单记录</h3>
                <p>安全可靠，账单信息实时查询</p>
              </li>
              <li>
                <img src={icon3} />
                <h3>快速提现</h3>
                <p>支持各大银行，即时到账</p>
              </li>
            </ul>
          </div>
        </div>
      );
    } else {
      // 只要开通了[企业账户|个人账户]其中一个，就显示详情页面
      return (
        <WalletDetailPage
          userInfo={userInfo}
          accounts={accounts}
          goToBindPage={() => {
            this.goToBindPage();
          }}
          goRegisterPage={(type: EAccountMemberType) => this.onRegister(type)}
          refreshAccounts={() => {
            this.initData();
          }}
        />
      );
    }
  }

  onRegister(type: EAccountMemberType) {
    const { match } = this.props;
    const typeStr = type === EAccountMemberType.Enterprise ? 'enterprise' : 'individual';
    this.props.history.push(`${match.path}/register/${typeStr}`);
  }

  /**
   * 前往绑卡页面
   */
  goToBindPage() {
    const { match } = this.props;
    this.props.history.push(`${match.path}/bindCard`);
  }

  async initData() {
    this.setState({ isLoading: true });
    const info = await this.walletService.getAccounts();
    if (info) {
      this.setState({ account: info, isLoading: false });
    } else {
      this.setState({ isLoading: false });
    }
  }

  private getAccount(type: EAccountMemberType = EAccountMemberType.Individual) {
    const { account } = this.state;
    return account.find(a => a.member_type === type);
  }
}

export default WalletPage;



// WEBPACK FOOTER //
// ./src/components/views/Wallet/WalletPage.tsx